import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges  } from '@angular/core';
import { ChatConsultant, ChatRollMessage, ChatUser, ChatUserType } from '../model/discovery-chat.interface';
import { UtilsService } from '../../moov-common/services/utils/utils.service';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-chat-roll',
  templateUrl: './chat-roll.component.html',
  styleUrls: ['./chat-roll.component.scss'],
})
export class ChatRollComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  // @ViewChild('chatRoll') private chatRoll: ElementRef;
  @Input() chatMsgs: ChatRollMessage[];
  @Output() selectDifferentAnswerEvent = new EventEmitter();
  
  changeLog: string[] = [];
  chatParticipantInitials: string;
  imageRootFolder = "assets/common/";

  constructor(public readonly utilsService: UtilsService) {
    super();
  }

  ngOnInit(): void {
    this.chatParticipantInitials = this.utilsService.getInitialis(this.user?.firstName, this.user?.lastName);
  }

    
  ngOnChanges(changes: SimpleChanges) {
  }

  isConsultant(val: ChatUserType): boolean {
    return (val === ChatUserType.Consultant);
  }

  selectDifferentAnswer(){
    this.selectDifferentAnswerEvent.emit();
  }
}
